export { InvestmentBanner } from './InvestmentBanner'
